var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tenant && _vm.tenant.id)?_c('div',[_c('OnboardingSupervisionNotice',{attrs:{"level":_vm.tenant.supervisionLevel}}),_c('h3',{staticClass:"text-h6 mb-2"},[_vm._v(_vm._s(_vm.$t("supervision.history.title")))]),_c('SupervisionHistoryList',{ref:"history",attrs:{"tenant-id":_vm.tenant.id}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }